import { CellValue } from '@/shared/ui/data/EditableGrid/types/cell.types';
import { Diff } from '@/shared/ui/data/EditableGrid/types/core.type';

function isEmpty(value: CellValue): boolean {
  if (value === null || value === undefined) return true;
  return typeof value === 'string' && value.trim() === '';
}

export function calculateDiff(value: CellValue, prev?: CellValue): Diff {
  const prevEmpty = isEmpty(prev);
  const valueEmpty = isEmpty(value);

  if (prevEmpty && valueEmpty) return 'unchanged';
  if (prevEmpty && !valueEmpty) return 'added';
  if (!prevEmpty && valueEmpty) return 'deleted';
  if (value === prev) return 'unchanged';
  return 'changed';
}

export function getDiffClasName(diff: Diff): string {
  switch (diff) {
    case 'added':
      return 'cell-diff-added';
    case 'changed':
      return 'cell-diff-modified';
    case 'deleted':
      return 'cell-diff-deleted';
    case 'unchanged':
    default:
      return '';
  }
}

export function getDiffColor(diff: Diff): string {
  switch (diff) {
    case 'added':
      return 'bg-green-50 border-green-300';
    case 'changed':
      return 'bg-yellow-50 border-yellow-300';
    case 'deleted':
      return 'bg-red-50 border-red-300 line-through';
    case 'unchanged':
    default:
      return '';
  }
}
